import { createContext, useState } from 'react';
import { defaultMe } from '../MeContext';
import { decideInitialTab } from '../helpers/decideInitialTab';


const DashboardContext = createContext()

export const useDashboardContext = (whoami) => {
    const searchParams = new URLSearchParams(document.location.search)
	const presetAccess_id = searchParams.get("access_id") || undefined
	const [openWhistle, setOpenWhistle] = useState(presetAccess_id)
	const [updateData, setUpdateData] = useState(false)
	const me = defaultMe(whoami)
	const userRoles = (me && me.roles) || undefined;
	const [currentActiveTab, setCurrentActiveTab] = useState(decideInitialTab(userRoles, presetAccess_id));

	const handleSetActiveTab = (tab) => {
		setUpdateData(true)
		localStorage.setItem('dashboardTab', tab);
		setCurrentActiveTab(tab)
	}

	return {
		activeTab: currentActiveTab,
		setActiveTab: handleSetActiveTab,
		openWhistle,
		setOpenWhistle,
		updateData,
		setUpdateData
	}
}

export default DashboardContext
